import { render, staticRenderFns } from "./defaultHeader.vue?vue&type=template&id=0bf9420c&scoped=true"
import script from "./defaultHeader.vue?vue&type=script&lang=js"
export * from "./defaultHeader.vue?vue&type=script&lang=js"
import style0 from "./defaultHeader.vue?vue&type=style&index=0&id=0bf9420c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf9420c",
  null
  
)

export default component.exports